import { signalStore } from '@ngrx/signals';

import { withAgency } from './features/with-agency';

export const ComplaintStore = signalStore({ providedIn: 'root' }, withAgency());
